import React from "react";
import webI from '../../images/home/web-application.png';

function WebApplication() {
  return (
    <>

      <Hero />

      <section className="service-content-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={webI}
                alt="Web Application Development"
                className="service-main-image"
              />
            </div>

            <div className="col-lg-6">
              <div className="service-content">

                <h2>Powerful Applications Accessible From Anywhere</h2>

                <p>
                  We develop modern web applications that help businesses
                  manage operations, customers, data, and digital services.
                </p>

                <p>
                  Our applications are designed to be responsive, secure,
                  maintainable, and scalable for future requirements.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Features />
      <CTA />
    </>
  );
}

function Hero() {
  return (
    <section
      className="service-page-hero"
      style={{ backgroundColor: '#002952' }}
    >
      <div className="container">
        <div className="service-hero-content">

          <h1>Web Application Development</h1>
          <p style={{ color: '#FF7D37' }}>
            Modern web applications designed to improve <br />business operations
            and customer experiences.
          </p>
        </div>
      </div>
    </section>
  );
}

function Features() {
  return (
    <section className="service-features-section">
      <div className="container">
        <div className="section-heading text-center">

          <h2>Modern Web Applications</h2>
        </div>

        <div className="row g-4">
          {[
            ["Responsive Design", "Applications that work smoothly across desktop, tablet, and mobile devices."],
            ["Secure Architecture", "Reliable application architecture designed with security and maintainability in mind."],
            ["API Integration", "Connect applications with third-party services and business systems through APIs."]
          ].map(([title, text]) => (
            <div className="col-lg-4 col-md-6" key={title}>
              <div className="service-feature-card">
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section className="service-cta-section">
      <div className="container">
        <div className="service-cta-box">
          <div>
            <span>WEB SOLUTIONS</span>
            <h2>Need A Web Application?</h2>
            <p>Let's turn your business requirements into a digital solution.</p>
          </div>
          <a href="/contactus" className="service-cta-button">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default WebApplication;